<script>
import toaster from "../../../common/toaster";
import preview from "../../common/preview.vue";

export default {
    name: "publish-preview-button",
    components: {preview},
    props: {
        disabled: Boolean,
        layer: {},
        screenId: String,
        elements: Array
    },
    computed: {
        translations() {
            return {
                preview: Lang.langGet('Preview'),
                emptyScreenWarning: Lang.langGet("Filter the list for a screen to be able to see the preview for this screen."),
            }
        },
        resolution() {
            return this.layer.width + 'x' + this.layer.height;
        }
    },
    data() {
        return {
            previewing: false,
            url: '',
            aspect: '1:1',
        }
    },
    methods: {
        preview() {
            if (this.previewing) return;

            if (!this.screenId) {
                toaster.warning(this.translations.emptyScreenWarning);
                return;
            }

            this.previewing = true;

            const visible = {};

            this.elements.forEach((element) => {
                if (!element.data.hidden) {
                    visible[element.id] = 1;
                }
            });

            axios.post('/content/publish/preview', {
                id: this.layer.id,
                project: Laravel.activeProject,
                user: Laravel.activeUser,
                visible,
                limit_screen: this.screenId,
                resolution: this.resolution
            }).then((response) => {
                this.url = response.data.url;
                this.aspect = response.data.aspect;
                EaseEventBus.fire('showContentPreview');
            }).catch((error) => {
                if (error.response?.status === 401) {
                    window.location = '/login';
                }
            }).finally(() => {
                this.previewing = false;
            });
        },
    },
    mounted() {
        EaseEventBus.listen('updatePreviewProperties', ({url, aspect}) => {
            this.url = url;
            this.aspect = aspect;
            EaseEventBus.fire('showContentPreview');
        });
    }
}
</script>

<template>
    <div>
        <v-btn :disabled="disabled"
               class="btn btn-secondary"
               @click="preview">
            <v-icon left>
                far {{previewing ? 'fa-spinner fa-spin-pulse' : 'fa-eye'}}
            </v-icon>
            {{ translations.preview }}
        </v-btn>
        <preview :url="url" :aspect="aspect" :resolution="resolution"/>
    </div>
</template>
